import type {
  UseDealDiscounts,
  UseDealDiscountsDatum,
} from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import { useApolloQueries } from '@openx/utils/apollo/useApolloQueries.ts';
import { useMemo } from 'react';
import { GetCuratedDealBuyerDiscountListDocument } from '../../../graphql/query/curatedDealBuyerDiscount/GetCuratedDealBuyerDiscountList.generated.tsx';
import type { CuratedDealBuyerDiscountApi } from '../../../types/curatedDealBuyerDiscount.ts';

export const useDealDiscounts: UseDealDiscounts = participants => {
  const { isAnyLoading, results } = useApolloQueries(
    GetCuratedDealBuyerDiscountListDocument,
    participants.map(participant => ({
      skip: !participant.demandPartnerId,
      variables: {
        params: {
          applied_to_demand_partner_id: participant.demandPartnerId,
          applied_to_received_seat_ids: participant.receivedSeatIds.join(','),
        },
      },
    }))
  );

  const discounts = useMemo<UseDealDiscountsDatum[]>(() => {
    const curatedDealBuyerDiscounts: CuratedDealBuyerDiscountApi[] = results.flatMap(result => {
      return result.data?.curatedDealBuyerDiscount?.objects ?? [];
    });

    return curatedDealBuyerDiscounts.map(curatedDealDiscount => ({
      banner_and_video_discount: curatedDealDiscount.banner_and_video_discount,
      ctv_discount: curatedDealDiscount.ctv_discount,
      demand_partner_id: curatedDealDiscount.demand_partner_id,
      id: curatedDealDiscount.id,
      name: curatedDealDiscount.name,
      seat_ids: curatedDealDiscount.seat_ids,
    }));
  }, [results]);

  return {
    data: discounts,
    isLoading: isAnyLoading,
  };
};
